__turbopack_context__.v({
  "disabled": "Default-module__3sdwMW__disabled",
  "heycarSlider": "Default-module__3sdwMW__heycarSlider",
  "isWithHistogram": "Default-module__3sdwMW__isWithHistogram",
  "sliderWrapper": "Default-module__3sdwMW__sliderWrapper",
});
